import { type JSX } from 'cdui-js';
import { NoDataIcon } from '../../../pages/mobile/icons';
import i18n from '../../../i18n';

export type DiFiNoDataProps = {
  text?: string;
  className?: string;
  style?: JSX.CSSProperties;

  hasIcon?: boolean;
  iconName?: string;
  iconRender?: () => JSX.Element;
};

const DEFAULT_CLASS = 'di-fi-no-data text-center padding-L';

export const DiFiNoData = (props: DiFiNoDataProps) => {
  const className = props.className ?? DEFAULT_CLASS;
  const hasIcon = props.hasIcon ?? false;

  return (
    <div
      class={`${className} flex-column align-center justify-space-center gap-8px font-s-XS color-L`.trim()}
      style={{
        ...props.style,
        width: '100%',
      }}
    >
      {hasIcon ? (props.iconRender ? props.iconRender() : <NoDataIcon />) : null}
      <div
        class="color-L font-s-XS text-center"
        style={{ 'line-height': '18px', 'letter-spacing': '-1%' }}
      >
        {props.text ?? i18n.Common.NoData}
      </div>
    </div>
  );
};
